import React from 'react';
import './InformationModals.css';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ContactIcon } from '../../icons/Icons';

const ContactModal = ({ modal, toggle }) => {
    return (
        <Modal isOpen={modal} toggle={toggle} className="contact-modal">
            <ModalHeader toggle={toggle} />
            <ModalBody>
                <ContactIcon />
                <h1>We’re based everywhere and anywhere.</h1>
                <p>Best way to get in touch if you have any questions is to ping us an email:</p>
                <a>team@validate.biz</a>
            </ModalBody>
            <ModalFooter />
        </Modal>
    );
};

export default ContactModal;
